import { render, staticRenderFns } from "./ui-social-icon.component.vue?vue&type=template&id=3fe5132a&"
import script from "./ui-social-icon.component.vue?vue&type=script&lang=ts&"
export * from "./ui-social-icon.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports